import { injectGlobal } from 'styled-components';

import { DEFAULT_FONT_FAMILY } from './variables.style';
import media from './media.style';

/* eslint-disable */
injectGlobal`
  * {
    font-family: ${DEFAULT_FONT_FAMILY};
    font-weight: normal;
  }
  h1 {
    font-size: 30px;
  }
  h2 {
    font-size: 38px;
    line-height: 1.25em;

    ${media.tabletL`
      font-size: 38px;
    `};
  }
  h3 {
    font-size: 20px;
  }
  h4 {
    font-size: 18px;
  }
  h5 {
    font-size: 16px;

    ${media.tabletL`
      font-size: 19px;
    `};
  }
  h6 {
    font-size: 16px;

    ${media.tabletL`
      font-size: 19px;
    `};
  }
  ul {
    margin: 0;
    padding: 0;
  }
  li {
    font-size: 16px;

    ${media.tabletL`
      font-size: 19px;
    `};
  }
  p {
    font-size: 16px;
    line-height: 1.5em;

    ${media.tabletL`
      font-size: 19px;
    `};
  }
  input[type="text"] {
    border-radius: 0;
    -webkit-appearance: none;
  }
  input[type="email"] {
    border-radius: 0;
    -webkit-appearance: none;
  }
  /* salon locator jp */
  [role="listbox"]{
    background: #f2f2f2;
    border-radius:0;
    .ant-select-dropdown-menu-item-active{
      background: white;
    }
    >li{
      padding-left: 30px;
      height: 50px;
      line-height: 50px;
    }
    >li:hover{
      background: #FFF;
    }

  }
  .ant-select-dropdown-menu{
    max-height: 475px!important;
  }
  a:hover {
    text-decoration: none;
  }
`;
/* eslint-enable */



// WEBPACK FOOTER //
// ./src/styles/global.style.js